import { render } from "./AccountDataEditor.vue?vue&type=template&id=2ec23be3&scoped=true"
import script from "./AccountDataEditor.vue?vue&type=script&lang=js"
export * from "./AccountDataEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec23be3"]])

export default __exports__